import { filterStateApiConnector } from 'apiConnector/blotters';
import { ofType } from 'redux-observable';
import type { SchedulerLike } from 'rxjs';
import { EMPTY, of } from 'rxjs';
import { catchError, debounceTime, filter, map, mergeMap, take, withLatestFrom } from 'rxjs/operators';
import { quoteBlotterFiltersLoadingFailed, quoteBlotterFiltersPersistenceFailed } from 'state/blotters/quote';
import { quoteBlotterFiltersLoadedThunk } from 'state/blotters/quote/quoteBlotter.thunks';
import type { EpicWithThunk } from 'state/state.common';

import { isNavigatingInQuoteBlotter } from '../../../utils/navigation/navigation';
import { toFilterState } from './filterStateEpics.helper';

export function persistFilterStateEpic(aggregationFrequency: number = 1000, scheduler?: SchedulerLike): EpicWithThunk {
  return (action$, state$, { httpClient, selectors: { getQuoteBlotterFiltersToPersist } }) =>
    action$.pipe(
      ofType('QUOTE_BLOTTER_FILTER_CHANGED', 'QUOTE_BLOTTER_ADVANCED_FILTERS_TOGGLED'),
      withLatestFrom(state$),
      debounceTime(aggregationFrequency, scheduler),
      mergeMap(([_, state]) => {
        const filters = getQuoteBlotterFiltersToPersist(state);
        return filterStateApiConnector(httpClient)
          .saveState(filters, 'quotes')
          .pipe(
            mergeMap(_ => EMPTY),
            catchError(() => {
              return of(quoteBlotterFiltersPersistenceFailed());
            }),
          );
      }),
    );
}

export function loadFilterStateEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient }) => {
    return actions$.pipe(
      filter(isNavigatingInQuoteBlotter),
      take(1),
      mergeMap(() => {
        return filterStateApiConnector(httpClient)
          .getState('quotes')
          .pipe(
            map(response => quoteBlotterFiltersLoadedThunk(toFilterState(response))),
            catchError(() => {
              return of(quoteBlotterFiltersLoadingFailed());
            }),
          );
      }),
    );
  };
}
